<template>
	<div
		class="rest-info-modal"
		:style="'border-top: 8px solid ' + restColor + ';' + 'border-bottom: 8px solid ' + restColor + ';'"
		v-if="showModal"
	>
		<div v-click-outside="handleClose">
			<div class="rest-info-modal-body">
				<div class="header">
					<img v-if="logo" class="img-responsive logo" :src="$CDN + logo" />
					<modal-header :title="title" @close-modal="handleClose" />
				</div>
				<div class="body">
					<div class="rest-info">
						<div v-if="street && cityStZip" class="info-item">
							<div class="label">
								<icon-base width="36" height="36" class="icon" :iconName="'Address'">
									<icon-location />
								</icon-base>
								ADDRESS
							</div>
							<div class="address">
								<span>{{ street }}</span>
								<span>{{ cityStZip }}</span>
							</div>
						</div>
						<div v-if="phone" class="info-item">
							<div class="label">
								<icon-base width="36" height="36" class="icon" :iconName="'Phone'">
									<icon-phone />
								</icon-base>
								PHONE
							</div>
							<div>
								<a
									v-for="(phoneNum, index) in phone"
									:key="phoneNum"
									:href="`tel:${phoneNum}`"
									class="phone"
								>
									<span v-if="index !== 0"> /</span>
									{{ phoneNum }}</a
								>
							</div>
						</div>
						<div v-if="restHours" class="info-item">
							<div class="label">
								<icon-base width="36" height="36" class="icon" :iconName="'Hours'">
									<icon-clock />
								</icon-base>
								BUSINESS HOURS
							</div>
							<div class="hours">
								<div class="hour" v-for="(day, key) in restHoursSorted" :key="key">
									<span>{{ key }}</span>
									<div class="hours-for-day">
										<span v-for="(hour, i) in day" :key="i">{{ hour }}</span>
									</div>
								</div>
							</div>
						</div>
						<div v-for="(menu, i) in allMenuHours" :key="i" class="info-item">
							<div class="label">
								<icon-base width="36" height="36" class="icon" :iconName="'Hours'">
									<icon-clock />
								</icon-base>
								{{ menu.menuHoursName }} HOURS
							</div>
							<div class="hours">
								<div
									class="hour"
									v-for="(hoursForDay, index) in sortMenuHours(menu.hours)"
									:key="index"
								>
									<span>{{ getDayName(hoursForDay.dayOfWeek) }}</span>
									<div class="hours-for-day">
										<span v-for="(setOfHours, i) in hoursForDay.hours" :key="i"
											>{{ setOfHours.openTime }} to {{ setOfHours.closeTime }}</span
										>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="map-wrapper">
						<img v-if="map" class="img-responsive map" :src="map" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import vClickOutside from "v-click-outside";

import ModalHeader from "./ModalItems/ModalHeader.vue";
import IconBase from "./IconBase.vue";
import IconLocation from "./icons/IconLocation.vue";
import IconPhone from "./icons/IconPhone.vue";
import IconClock from "./icons/IconClock.vue";

import { mapGetters } from "vuex";

export default {
	name: "RestInfoModal",
	components: {
		ModalHeader,
		IconBase,
		IconLocation,
		IconPhone,
		IconClock,
	},
	directives: {
		clickOutside: vClickOutside.directive,
	},
	props: {
		title: String,
		street: String,
		cityStZip: String,
		phone: {
			type: Array,
			default: () => [],
		},
		restHours: {
			type: Object,
			default: () => {},
		},
		map: String,
		logo: String,
		showModal: {
			type: Boolean,
			default: true,
		},
		restColor: {
			type: String,
			default: "#0184c6",
		},
	},
	computed: {
		...mapGetters({
			allMenuHours: "restMenu/allMenuHours",
		}),
		restHoursSorted: function () {
			var sortedHours = {
				Sunday: this.restHours.Sunday,
				Monday: this.restHours.Monday,
				Tuesday: this.restHours.Tuesday,
				Wednesday: this.restHours.Wednesday,
				Thursday: this.restHours.Thursday,
				Friday: this.restHours.Friday,
				Saturday: this.restHours.Saturday,
			};
			return sortedHours;
		},
	},
	methods: {
		handleClose() {
			this.$emit("close-modal");
		},
		submit() {
			console.log(this.$data);
		},
		sortMenuHours(hours) {
			var hoursReturn = [];
			for (var i = 1; i <= 7; i++) {
				var hoursAssociatedWithDayNumber = hours.filter((setOfHours) => setOfHours.dayOfWeek == i);
				if (hoursAssociatedWithDayNumber.length > 0) {
					var hoursForDay = {
						dayOfWeek: i,
						hours: hoursAssociatedWithDayNumber,
					};
					hoursReturn.push(hoursForDay);
				}
			}
			return hoursReturn;
		},
		getDayName: function (dayNumber) {
			var daysOfWeek = {
				1: "Sunday",
				2: "Monday",
				3: "Tuesday",
				4: "Wednesday",
				5: "Thursday",
				6: "Friday",
				7: "Saturday",
			};
			return daysOfWeek[dayNumber];
		},
	},
};
</script>

<style lang="scss" scoped>
.rest-info-modal {
	position: fixed;
	border-radius: 5px;
	top: 10%;
	left: 5%;
	right: 5%;
	z-index: 999;
	max-height: calc(100vh - 20%);
	overflow: auto;

	&:before {
		content: "";
		position: absolute;
		left: -10px;
		top: 20px;
		color: #ddd;
		padding: 8px 8px 8px 13px;
		margin-top: -10px;
		font-weight: 400;
		font-size: 11px;
		width: 142px;
		height: 40px;
		background-image: url("./assets/images/exclusive-left.png");
	}

	@media (min-width: $tabletLandscape) {
		left: 10%;
		right: 10%;
	}
}

.rest-info-modal-body {
	background-color: $white;
	padding: 50px 25px;
}

.header {
	display: flex;
	align-items: flex-start;
	flex-wrap: wrap;
	flex-direction: column-reverse;

	@media (min-width: $tabletPortrait) {
		flex-wrap: nowrap;
		flex-direction: row;
	}
}

.body {
	display: flex;
	flex-wrap: wrap;

	@media (min-width: $tabletLandscape) {
		flex-wrap: nowrap;
	}
}

.logo {
	padding-right: 25px;
	padding-bottom: 25px;
	max-width: 200px;
	height: auto;
}

.rest-info {
	width: 100%;
	display: flex;
	flex-direction: column;
	border-right: none;
	padding-right: 15px;
	margin-right: 15px;

	@media (min-width: $tabletLandscape) {
		width: 50%;
		border-right: 1px solid $gray_2;
	}
}

.info-item {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 15px;

	@media (min-width: $mobileLandscape) {
		flex-direction: row;
	}
}

.label {
	font-size: 1.8rem;
	font-weight: 900;
	text-transform: uppercase;
	letter-spacing: 1px;
	margin-bottom: 20px;
	display: flex;
	align-items: flex-end;
}

.icon {
	margin-right: 10px;
}

.info {
	display: flex;
	flex-direction: column;
}

.address,
.hours {
	display: flex;
	flex-direction: column;
	font-weight: 500;
	font-size: 1.4rem;
}

.hours {
	width: 100%;

	@media (min-width: $mobileLandscape) {
		width: 50%;
	}
}

.hour {
	display: flex;
	justify-content: space-between;
	border-bottom: dotted 0.5px;
}

.hours-for-day {
	display: grid;
	text-align: right;
}

.phone {
	text-decoration: none;
	font-weight: 500;
	font-size: 1.4rem;
	color: $royal;

	span {
		color: $black;
	}

	&:hover,
	&:focus {
		color: $tomato;
		text-decoration: underline;

		span {
			color: $black;
		}
	}
}

.map-wrapper {
	width: 100%;

	@media (min-width: $tabletLandscape) {
		width: 50%;
	}
}

.map {
	width: 100%;
	height: auto;
}
</style>